<template>
  <div>
  </div>
</template>

<script>
import axios from "axios";
import validator from "validator";

export default {
  name: "Home",
  data() {
    return {
      errors: {},
      messageRes: null,
      userContact: {
        fullName: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    sendMessage() {
      this.errors = {};
      if (validator.isEmpty(this.userContact.fullName))
        this.errors.fullName = "Full name is required!";
      if (validator.isEmpty(this.userContact.email))
        this.errors.email = "Email is required!";
      if (!validator.isEmail(this.userContact.email))
        this.errors.email = "Email must be valid!";
      if (validator.isEmpty(this.userContact.message))
        this.errors.message = "Message is required!";
      if (!Object.keys(this.errors).length) {
        let self = this;
        axios
          .post(`${process.env.VUE_APP_API}/api/send/mail`, this.userContact)
          .then((res) => {
            self.messageRes = res.data.message;
            self.resetForm();
          })
          .catch((err) => { });
      }
    },
    resetForm() {
      this.userContact = {};
    },
  },
};
</script>
